module.exports = __webpack_public_path__ + "static/githublogo-7c9651a497180337bfaec36cc320e182.png";